import { RouteProps } from 'react-router';
import STP from './index';
import STPInvestment from './STPInvestment';
import STPOtp from './STPOtp';
import STPSuccess from './STPSuccess';
import STPTo from './STPTo';
import { STPPaths } from './types';

const Routes: RouteProps[] = [
    {
        path: STPPaths.STP,
        component: STP,
        exact: true,
    },
    {
        path: STPPaths.to,
        component: STPTo,
    },
    {
        path: STPPaths.STPChangeRequest,
        component: STPInvestment,
    },
    {
        path: STPPaths.otp,
        component: STPOtp,
    },
    {
        path: STPPaths.success,
        component: STPSuccess,
    },
];

export { Routes as STPRoutes };
